<div class="component-container flex flex-col justify-center items-center gap-y-[2.5rem]">
  <div
    *ngFor="let eachParticipant of userDetails['participants']"
    class="each-participant-block flex flex-col justify-center items-center"
  >
    <div
      class="row flex flex-col md:flex-row
           justify-start items-center
            gap-y-[2rem] md:gap-[2.4rem]"
    >
      <div class="sub-row w-full md:w-1/2 flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">

        <div class="label w-2/5">
          Participant Name
        </div>

        <div
          (click)="goToMember(eachParticipant.id)"
          class="value w-3/5 clickable"
        >
          {{ eachParticipant['firstName'] }} {{ eachParticipant['lastName'] }}
        </div>

      </div>

      <div class="sub-row w-full md:w-1/2 flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">

        <div class="label w-2/5">
          Relationship
        </div>

        <div class="value w-3/5 relationship-value"
             [title]="eachParticipant['relation']">
          {{ eachParticipant['relation'] }}
        </div>

      </div>
    </div>
    <div
      class="row flex flex-col md:flex-row
           justify-start items-center
            gap-y-[2rem] md:gap-[2.4rem]"
    >
      <div class="sub-row w-full md:w-1/2 flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">

        <div class="label w-2/5">
          Group Name
        </div>

        <div class="value w-3/5">
          {{ eachParticipant['groupName'] }}
        </div>

      </div>

      <div class="sub-row w-full md:w-1/2 flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">

        <div class="label w-2/5">
          Group Start Date
        </div>

        <div class="value w-3/5">
          {{ eachParticipant['groupStartDate'] | date:'fullDate' }}
        </div>

      </div>
    </div>
    <div
      class="row flex flex-col md:flex-row
           justify-start items-center
            gap-y-[2rem] md:gap-[2.4rem]"
    >
      <div class="sub-row w-full md:w-1/2 flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">

        <div class="label w-2/5">
          Participant Status
        </div>

        <div class="value w-3/5">
          {{ eachParticipant['participantStatus']  }}
        </div>

      </div>

      <div class="sub-row w-full md:w-1/2 flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">

        <div class="label w-2/5">
          Group Status
        </div>

        <div class="value w-3/5">
          {{ eachParticipant['groupStatus']  }}
        </div>

      </div>
    </div>
    <div
      class="row flex flex-col md:flex-row
           justify-start items-center
            gap-y-[2rem] md:gap-[2.4rem]"
    >
      <div class="sub-row w-full md:w-1/2 flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">

        <div class="label w-2/5">
          Last Session
        </div>

        <div class="value w-3/5">
          {{ (eachParticipant['lastSession'] | date:'fullDate')  }}
        </div>

      </div>

      <div class="sub-row w-full md:w-1/2 flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">

        <div class="label w-2/5">
          Phone Number
        </div>

        <div class="value w-3/5">
          {{ eachParticipant['phoneNumber'] }}
        </div>

      </div>
    </div>
    <div
      class="row flex flex-col md:flex-row
           justify-start items-center
            gap-y-[2rem] md:gap-[2.4rem]"
    >
      <div class="sub-row w-full md:w-1/2 flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">

        <div class="label w-2/5">
          Consent form
        </div>

        <div class="value w-3/5">
          <span
            (click)="eachParticipant['consentDate'] ?
            hippaConsentClicked(eachParticipant) : {}"
            [class.link]="eachParticipant['consentDate']"
          >
          {{ eachParticipant['consentDate'] ? 'View' : 'Not Completed' }}
           </span>
          <span
            (click)="triggerNotification('hippaConsent', eachParticipant)"
            *ngIf="!eachParticipant['consentDate'] && loggedInUserRole !=
            roles['adult'] && loggedInUserRole != roles['participant'] &&
            loggedInUserRole < userDetails?.role"
            class="link reminder-link"
          >
         Send Reminder
           </span>
        </div>

      </div>

      <div class="sub-row w-full md:w-1/2 flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">

        <div class="label w-2/5">
          Assent
        </div>

        <div class="value w-3/5">
          <span
            (click)="eachParticipant['assentDate'] ?
            hippaAssentClicked(eachParticipant) : {}"
            [class.link]="eachParticipant['assentDate']"
          >
          {{ eachParticipant['assentDate'] ? 'View' : 'Not Completed' }}
          </span>
          <span
            (click)="triggerNotification('hippaAssent', eachParticipant)"
            *ngIf="!eachParticipant['assentDate'] && loggedInUserRole !=
            roles.adult && loggedInUserRole != roles.participant &&
            loggedInUserRole < userDetails.role
            "
            class="link reminder-link"
          >
        Send Reminder
          </span>
        </div>

      </div>
    </div>
    <hr
      class="hr line-break mt-[2.5rem]"
    >
  </div>
</div>
